import React, { useCallback } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  ErrorOutline,
  Add,
  PhotoCamera,
  InsertDriveFile,
  AutoAwesomeMosaic,
  ReplyOutlined,
  Close,
  RocketLaunch,
} from "@mui/icons-material";
import dummyImage from "../../assets/dummy_image.jpg";
import { formatText } from "../../helpers";
import { IAcitvityWhatsAppConversationLogsProps } from "./Activity.types";
import { LoadState } from "../../constants/enums";
import { useDispatchWrapper } from "../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";

import {
  clearWhatsAppChat,
  fetchIsWhatsAppConversationStartedAsync,
  fetchWhatsAppConversationListAsync,
  upsertMessage,
  upsertWhatsAppMessage,
} from "../../redux/activity/activityActions";
import {
  IWhatsAppActivity,
  IWhatsAppActivityPayload,
} from "../../redux/activity/activity.types";
import { CustomTextField } from "../../components/formsComponents";
import { useFormik } from "formik";
// import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";
import { useWhatsappMessageReceivedSocket } from "../../contexts/SocketProvider/SocketProvider.hooks";
import { showMessage } from "../../redux/messages/messagesActions";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import SendIcon from "@mui/icons-material/Send";
// import { WhatsAppQRScanRequired } from "../WhatsAppQRScanRequired/WhatsAppQRScanRequired";
import { getWhatsappWebServiceValue } from "../../services/subcriptionApi";
import { useWhatsAppStatus } from "../../contexts/WhatsAppStatusProvider";
import WhatsappBgImg from "../../assets/whatsapp_bg_img.jpg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import { SelectWhatsappTemplate } from "../WhatsAppTemplate/components/SelectWhatsappTemplate";
import { alpha } from "@mui/material/styles";
import { useFilePreview } from "../../hooks/useFilePreview";
// import { WhatsAppMessageRow } from "./WhatsAppMessageRow";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
// import { MapPicker } from "../components/MapPicker";
// import { SelectQuickReplyTemplate } from "../../QuickReplyTemplate/components/SelectQuickReplyTemplate";
import { uploadFile } from "../../features/FileUpload/utils";
import {
  getFileExtensionType,
  IFileExtension,
} from "../../components/FileUploadIcon/helpers";
import { WhatsAppQRScanRequired } from "../../views/Chatbot/WhatsAppQRScanRequired/WhatsAppQRScanRequired";
import WhatsAppMessageRow from "../../views/Chatbot/ChatCenter/WhatsAppMessageRow";
import { SelectQuickReplyTemplate } from "../../views/QuickReplyTemplate/components/SelectQuickReplyTemplate";
import { SelectWhatsappTemplate } from "../../views/WhatsAppTemplate/components/SelectWhatsappTemplate";
import { MapPicker } from "../../views/Chatbot/components/MapPicker";

const MESSAGES_PER_PAGE = 10
export const ActivityWhatsAppLogs = React.forwardRef<
  { handleRefresh: () => void },
  IAcitvityWhatsAppConversationLogsProps
>((props, ref) => {
  const {
    phone,
    useQRSend: propUseQRSend,
    paddingBottom,
    onForwardMessage,
    onRestrictMessage,
    onShowRestrictedMessage,
    visibleRestrictedMessages = new Set(),
    message,
  } = props;
  const dispatch = useDispatchWrapper();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const { previewFile } = useFilePreview();
  // const { comapny: companyOutlet } = useBillingCompanyContext();
  const { useMetaService, whatsappNumber } = useWhatsAppStatus();
  const socketResponse = useWhatsappMessageReceivedSocket();

  const { list, loading, error, hasMoreRecords } = useSelector(
    (s: IStoreState) => s.acitivty.whatsApp
  );

  const chatContainerRef = React.useRef<HTMLDivElement | null>(null);

  /** 🔑 SCROLL REFS */
  const isFetchingOldRef = React.useRef(false);
  const isUserAtBottomRef = React.useRef(true);
  const restoreFromBottomRef = React.useRef<number | null>(null);
  const didInitialScrollRef = React.useRef(false);
  const isRestoringScrollRef = React.useRef(false);


  const [messagesList, setMessagesList] = React.useState<IWhatsAppActivity[]>([]);
  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: MESSAGES_PER_PAGE,
  });


  const [buttonClicked, setButtonClicked] = React.useState<string | null>(null);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [showAttachmentOptions, setShowAttachmentOptions] = React.useState(false);
  const [replyingTo, setReplyingTo] = React.useState<IWhatsAppActivity | null>(null);
  const [scannedPhoneNumber, setScannedPhoneNumber] = React.useState("");
  const [isStart, setIsStart] = React.useState(1);

  const [showSelectWhatsappTemplate, setShowSelectWhatsappTemplate] =
    React.useState<{
      isFromStartConversation: boolean;

      isNormalSelect: boolean;
    }>({
      isFromStartConversation: false,

      isNormalSelect: false,
    });

  const [showSelectQuickReplyTemplate, setShowSelectQuickReplyTemplate] = React.useState<boolean>(false);

  const [showLocationPicker, setShowLocationPicker] = React.useState<boolean>(false);


  const currentUseQRSend = propUseQRSend !== undefined ? propUseQRSend : false;


  const fetchInitialLogs = useCallback(
    async (disableLoader?: boolean) => {
      dispatch(
        fetchWhatsAppConversationListAsync(
          phone,
          1,
          tablePagination.rowsInPerPage,
          true,
          // companyOutlet.company_outlet_uuid,
          undefined,
          getCorrectWhatsappWebService(currentUseQRSend),
          undefined,
          disableLoader
        )
      );
    },
    [
      dispatch,
      phone,
      tablePagination.rowsInPerPage,
      // companyOutlet.company_outlet_uuid,
      currentUseQRSend,
      useMetaService,
    ]
  );

  const fetchMoreLogs = useCallback(
    async (pageNumber: number, onComplete?: () => void) => {
      dispatch(
        fetchWhatsAppConversationListAsync(
          phone,
          pageNumber,
          tablePagination.rowsInPerPage,
          false,
          // companyOutlet.company_outlet_uuid,
          undefined,
          getCorrectWhatsappWebService(currentUseQRSend),
          onComplete
        )
      );
    },
    [dispatch, phone, tablePagination.rowsInPerPage, currentUseQRSend, useMetaService]
  );

  /** 🔑 SCROLL HANDLER */
  const handleScroll = React.useCallback(() => {
    const el = chatContainerRef.current;
    if (!el) return;

    const { scrollTop, scrollHeight, clientHeight } = el;

    // Are we near bottom?
    isUserAtBottomRef.current =
      scrollHeight - scrollTop - clientHeight < 60;

    // Load older messages
    if (
      scrollTop <= 40 &&
      !isFetchingOldRef.current &&
      loading !== LoadState.InProgress &&
      hasMoreRecords
    ) {
      isFetchingOldRef.current = true;

      // ✅ CAPTURE DISTANCE FROM BOTTOM
      restoreFromBottomRef.current = scrollHeight - scrollTop;

      const nextPage = tablePagination.pageNumber + 1;
      setTablePagination(p => ({ ...p, pageNumber: nextPage }));

      fetchMoreLogs(nextPage, () => {
        isFetchingOldRef.current = false;
      });
    }
  }, [loading, hasMoreRecords, tablePagination.pageNumber, fetchMoreLogs]);

  React.useLayoutEffect(() => {
    const el = chatContainerRef.current;
    if (!el || messagesList.length === 0) return;

    // 🔁 Restore scroll after older messages
    if (restoreFromBottomRef.current !== null) {
      const distanceFromBottom = restoreFromBottomRef.current;
      restoreFromBottomRef.current = null;

      requestAnimationFrame(() => {
        el.scrollTop = el.scrollHeight - distanceFromBottom;
      });
      return;
    }

    // ⬇ ALWAYS scroll to bottom when page === 1
    if (tablePagination.pageNumber === 1) {
      requestAnimationFrame(() => {
        el.scrollTop = el.scrollHeight;
      });
    }
  }, [messagesList, tablePagination.pageNumber]);


  const scrollToBottom = React.useCallback((smooth = false) => {
    const el = chatContainerRef.current;
    if (!el) return;

    el.scrollTo({
      top: el.scrollHeight,
      behavior: smooth ? "smooth" : "auto",
    });
  }, []);



  const getCorrectWhatsappWebService = (useQRSend: boolean) => {
    return getWhatsappWebServiceValue(useMetaService, useQRSend);
  };

  const handleViewDocumnetClick = (fileUrl: string) => {
    previewFile(fileUrl);
  };

  type ReplySnippet =
    | { kind: "text"; text: string }
    | {
      kind: "media";
      mediaType: IFileExtension;
      url: string;
      duration?: number | string;
    }
    | { kind: "none" };

  const getAttachmentUrl = React.useCallback(
    (attachments: any): string | null => {
      if (!attachments) return null;
      if (typeof attachments === "string") return attachments;
      if (Array.isArray(attachments)) return attachments.find(Boolean) || null;
      if (attachments?.url) return attachments.url;
      if (attachments?.path) return attachments.path;
      return null;
    },
    []
  );

  const getMessageSnippet = React.useCallback(
    (message?: IWhatsAppActivity | null): ReplySnippet => {
      if (!message) return { kind: "none" };

      if (message.message) return { kind: "text", text: message.message };

      if (Array.isArray(message.content)) {
        const firstText = message.content.find(
          (item: any) => typeof item?.text === "string" && item.text
        );
        if (firstText?.text) {
          return { kind: "text", text: firstText.text };
        }
      }

      const attachmentUrl = getAttachmentUrl(message.attachments);
      if (attachmentUrl) {
        const mediaType = getFileExtensionType(attachmentUrl);
        const duration =
          (message as any)?.raw_payload?.duration ??
          (message as any)?.raw_payload?.media?.duration ??
          (message as any)?.raw_payload?.media?.seconds ??
          (message as any)?.raw_payload?.seconds;

        return {
          kind: "media",
          mediaType,
          url: attachmentUrl,
          duration,
        };
      }

      if (message.message_type) {
        return { kind: "text", text: formatText(message.message_type) };
      }

      return { kind: "none" };
    },
    [getAttachmentUrl]
  );

  const snippet = getMessageSnippet(replyingTo);
  const formatReplyDuration = (duration?: number | string) => {
    if (duration === undefined || duration === null) return "";
    const totalSeconds = Number(duration);
    if (Number.isNaN(totalSeconds)) return "";
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const renderReplySnippet = () => {
    if (snippet.kind === "media") {
      const formattedDuration = formatReplyDuration(snippet.duration);

      if (snippet.mediaType === "IMAGE") {
        return (
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Stack direction="row" spacing={1} alignItems="center" flex={1}>
              <PhotoCamera fontSize="small" color="primary" />
              <Typography variant="body2" sx={{ fontWeight: 400 }}>
                Photo
              </Typography>
            </Stack>
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: 1,
                overflow: "hidden",
                flexShrink: 0,
                backgroundColor: theme.palette.grey[300],
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => handleViewDocumnetClick(snippet.url)}
            >
              <img
                src={snippet.url}
                alt="Attachment"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = dummyImage;
                }}
              />
            </Box>
          </Stack>
        );
      }

      if (snippet.mediaType === "VIDEO") {
        return (
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Stack direction="row" spacing={1} alignItems="center" flex={1}>
              <SmartDisplayIcon fontSize="small" color="primary" />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  Video
                </Typography>
                {formattedDuration && (
                  <Typography variant="caption" color="text.secondary">
                    {formattedDuration}
                  </Typography>
                )}
              </Box>
            </Stack>
            <IconButton
              size="small"
              onClick={() => handleViewDocumnetClick(snippet.url)}
              aria-label="Open video"
            >
              <SmartDisplayIcon fontSize="small" color="primary" />
            </IconButton>
          </Stack>
        );
      }

      if (snippet.mediaType === "PDF") {
        return (
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Stack direction="row" spacing={1} alignItems="center" flex={1}>
              <InsertDriveFile fontSize="small" color="primary" />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                PDF
              </Typography>
            </Stack>
            <IconButton
              size="small"
              onClick={() => handleViewDocumnetClick(snippet.url)}
              aria-label="Open PDF"
            >
              <InsertDriveFile fontSize="small" color="primary" />
            </IconButton>
          </Stack>
        );
      }

      return (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: "0.85rem",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          Media message
        </Typography>
      );
    }

    if (snippet.kind === "text") {
      return (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: "0.85rem",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          {snippet.text || "Media message"}
        </Typography>
      );
    }

    return null;
  };
  const handleReplySelect = React.useCallback((message: IWhatsAppActivity) => {
    setReplyingTo(message);
    setShowAttachmentOptions(false);
  }, []);

  const clearReplySelection = React.useCallback(() => {
    setReplyingTo(null);
  }, []);

  const { values, handleChange, handleSubmit, resetForm, setFieldValue } =
    useFormik<IWhatsAppActivityPayload>({
      initialValues: {
        message: "",
        toNumber: "",
        fromNumber: null,
        is_automatic_message: 0,
        objectVariables: { bodyVar: [] },
        image: { link: "" },
        document: { link: "", caption: "" },
        video: { link: "", caption: "" },
        templateName: "",
        // company_outlet_uuid: companyOutlet.company_outlet_uuid,
        // company_outlet_name: companyOutlet.company_outlet_name,
        attachments: [],
      },
      validate: (values) => {
        const errors: any = {};
        return errors;
      },

      onSubmit: (values) => {
        setSaveLoading(true);

        if (buttonClicked === "send") {
          const payload: IWhatsAppActivityPayload = {
            fromNumber: null,
            toNumber: phone,
            is_automatic_message: 0,
            message: values.message,
            whatsapp_web_service: currentUseQRSend,
            // company_outlet_name: companyOutlet.company_outlet_name,
            // company_outlet_uuid: companyOutlet.company_outlet_uuid,
          };
          if (replyingTo?.conversation_id) {
            payload.reply_from_conversation_id = replyingTo.conversation_id;
          }

          dispatch(
            upsertWhatsAppMessage(payload, (isSuccess) => {
              if (isSuccess) {
                resetForm();
                setSaveLoading(false);
                scrollToBottom(true);
                setReplyingTo(null);
              }
            })
          );
        }
      },
    });



  const checkStatus = useCallback(() => {
    dispatch(
      fetchIsWhatsAppConversationStartedAsync(phone, (value) => {
        setIsStart(value);
      })
    );
  }, [dispatch, phone]);



  // const checkScannedPhoneNumber = useCallback(() => {
  //   dispatch(
  //     fetchScannedPhoneNumberAsync(
  //       companyOutlet.company_outlet_uuid,
  //       (value) => {
  //         setScannedPhoneNumber(value);
  //       }
  //     )
  //   );
  // }, [dispatch, companyOutlet.company_outlet_uuid]);

  const handleRefresh = useCallback(
    (disableLoader?: boolean) => {
      if (!phone) {
        console.error("Phone is undefined or empty!");
        return;
      }

      // if (!companyOutlet?.company_outlet_uuid) {
      //   console.error("company_outlet_uuid is undefined!");
      //   return;
      // }

      checkStatus();
      // if (currentUseQRSend) {
      //   checkScannedPhoneNumber();
      // }

      setTablePagination({ pageNumber: 1, rowsInPerPage: MESSAGES_PER_PAGE });
      fetchInitialLogs(disableLoader);
      scrollToBottom(true);
    },
    [
      checkStatus,
      // checkScannedPhoneNumber,
      phone,
      // companyOutlet.company_outlet_uuid,
      fetchInitialLogs,
    ]
  );

  const handleLocationSelect = async (place: any) => {
    if (!place || !place.value) return;

    const placeId = place.value.place_id;
    if (!placeId) return;

    try {
      setSaveLoading(true);
      // Get the detailed place information using the placeId
      const response = await geocodeByPlaceId(placeId);
      const { geometry, address_components, formatted_address } = response[0];
      const { lat, lng } = geometry.location;

      // Extract address components
      const address = formatted_address || "";
      let name = "";

      // Try to get a meaningful name (establishment name, locality, or route)
      for (const component of address_components) {
        const types = component.types;
        if (types.includes("establishment")) {
          name = component.long_name;
          break;
        } else if (types.includes("locality") && !name) {
          name = component.long_name;
        } else if (types.includes("route") && !name) {
          name = component.long_name;
        }
      }

      // If no name found, use the first part of the address
      if (!name && address) {
        name = address.split(",")[0];
      }

      const payload: IWhatsAppActivityPayload = {
        fromNumber: null,
        toNumber: phone,
        is_automatic_message: 0,
        // company_outlet_uuid: companyOutlet.company_outlet_uuid,
        // company_outlet_name: companyOutlet.company_outlet_name,
        whatsapp_web_service: currentUseQRSend,
        location: {
          latitude: lat(),
          longitude: lng(),
          name: name || "Selected Location",
          address: address,
        },
      };

      if (replyingTo?.conversation_id) {
        payload.reply_from_conversation_id = replyingTo.conversation_id;
      }

      dispatch(
        upsertWhatsAppMessage(payload, (isSuccess) => {
          if (isSuccess) {
            dispatch(
              showMessage({
                type: "success",
                message: "Location sent successfully via WhatsApp",
                displayAs: "snackbar",
              })
            );
            setReplyingTo(null);
            setShowLocationPicker(false);
          } else {
            dispatch(
              showMessage({
                type: "error",
                message: "Failed to send location via WhatsApp",
                displayAs: "snackbar",
              })
            );
          }
          setSaveLoading(false);
          setShowLocationPicker(false);
        })
      );
    } catch (error) {
      console.error("Error fetching location data:", error);
      dispatch(
        showMessage({
          type: "error",
          message: "Failed to get location details",
          displayAs: "snackbar",
        })
      );
      setSaveLoading(false);
    }
  };

  const handleSendWhatsapp = async (source: string) => {
    if (source === "LOCATION") {
      setShowLocationPicker(true);
      setShowAttachmentOptions(false);
      return;
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept =
      source === "IMAGE"
        ? "image/*"
        : source === "VIDEO"
          ? "video/*"
          : source === "DOCUMENT"
            ? "application/pdf,.doc,.docx,.txt"
            : source === "AUDIO"
              ? "audio/*"
              : "";

    input.onchange = async (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;

      setSaveLoading(true);

      try {
        const fileUrl = await uploadFile(
         file,
          "WHATSAPP_MARKET_CAMPAIGN",
         file.name || "",
          {
            // company_outlet_uuid: companyOutlet.company_outlet_uuid,
          },
          // onWarning: (message) => {
          //   dispatch(
          //     showMessage({
          //       type: "warning",
          //       message: message,
          //       displayAs: "snackbar",
          //     })
          //   );
          // },
        );

        const payload: IWhatsAppActivityPayload = {
          fromNumber: null,
          toNumber: phone,
          is_automatic_message: 0,
          // company_outlet_uuid: companyOutlet.company_outlet_uuid,
          // company_outlet_name: companyOutlet.company_outlet_name,
          whatsapp_web_service: currentUseQRSend,
        };

        if (replyingTo?.conversation_id) {
          payload.reply_from_conversation_id = replyingTo.conversation_id;
        }

        if (source === "IMAGE") {
          payload.image = { link: fileUrl };
        } else if (source === "DOCUMENT") {
          payload.document = { link: fileUrl, caption: "" };
        } else if (source === "VIDEO") {
          payload.video = { link: fileUrl, caption: "" };
        }

        dispatch(
          upsertWhatsAppMessage(payload, (isSuccess) => {
            if (isSuccess) {
              dispatch(
                showMessage({
                  type: "success",
                  message: "Message sent successfully via WhatsApp",
                  displayAs: "snackbar",
                })
              );
              setReplyingTo(null);
            } else {
              dispatch(
                showMessage({
                  type: "error",
                  message: "Failed to send message via WhatsApp",
                  displayAs: "snackbar",
                })
              );
            }
            setSaveLoading(false); // ✅ Reset here after dispatch callback
          })
        );
      } catch (error) {
        dispatch(
          showMessage({
            type: "error",
            message: "Failed to upload file",
            displayAs: "snackbar",
          })
        );
        setSaveLoading(false); // ✅ Also reset on error
      }
    };

    input.click();
  };



  React.useEffect(() => {
    checkStatus();
    // if (currentUseQRSend) {
    //   checkScannedPhoneNumber();
    // }
  }, [phone, checkStatus]);

  React.useEffect(() => {
    if (phone && useMetaService !== null) {
      setMessagesList([]);
      fetchInitialLogs();
    }

    return () => {
      dispatch(clearWhatsAppChat());
    };
  }, [phone, fetchInitialLogs, dispatch, useMetaService]);



  React.useEffect(() => {
    setTablePagination({ pageNumber: 1, rowsInPerPage: MESSAGES_PER_PAGE });
    didInitialScrollRef.current = false;
    restoreFromBottomRef.current = null;
    isRestoringScrollRef.current = false;
    isFetchingOldRef.current = false;
    setReplyingTo(null);
  }, [phone]);

  React.useEffect(() => {
    if (message) {
      setFieldValue("message", message);
    }
  }, [message, setFieldValue]);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showAttachmentOptions) {
        const target = event.target as Element;
        if (!target.closest("[data-attachment-options]")) {
          setShowAttachmentOptions(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAttachmentOptions]);

  React.useImperativeHandle(ref, () => ({
    handleRefresh,
  }), [handleRefresh]);

  React.useEffect(() => {
    if (!list || list.length === 0) return;

    setMessagesList(prev => {
      if (tablePagination.pageNumber === 1) return list;

      const existingIds = new Set(prev.map(m => m.conversation_id));
      const older = list.filter(m => !existingIds.has(m.conversation_id));

      return [...older, ...prev]; // prepend
    });
  }, [list, tablePagination.pageNumber]);


  React.useEffect(() => {
    if (!socketResponse) return;
    // const currentOutlet = companyOutlet.company_outlet_uuid;
    const messageOutlet = socketResponse.conversation.company_outlet_uuid;
    // if (currentOutlet !== messageOutlet) return;

    if (socketResponse.status === "MESSAGE_RECEIVED") {
      const newMessage = socketResponse.conversation;
      setMessagesList((prevMessages) => {
        const messageExists = prevMessages.some(
          (msg) => msg.conversation_id === newMessage.conversation_id
        );

        if (!messageExists) {
          // Only increment new message count if user is NOT at the bottom
          if (isUserAtBottomRef.current) {
            requestAnimationFrame(() => {
              chatContainerRef.current?.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: "smooth",
              });
            });
          }

          return [...prevMessages, newMessage as any as IWhatsAppActivity];
        }

        return prevMessages;
      });
      setIsStart(1)
    }

    if (socketResponse.status === "MESSAGE_SENT") {
      const newMessage = socketResponse.conversation;

      // const currentCompanyOutletUuid = companyOutlet.company_outlet_uuid;
      const messageToNumber = newMessage.recipient_number;
      const messageCompanyOutletUuid = (newMessage as any).company_outlet_uuid;

      // if (
      //   messageToNumber !== phone ||
      //   // messageCompanyOutletUuid !== currentCompanyOutletUuid
      // ) {
      //   return;
      // }

      dispatch(
        upsertMessage(socketResponse.conversation as any as IWhatsAppActivity)
      );
    }

    if (socketResponse.status === "MESSAGE_STATUS_RECEIVED") {
      const newMessage = socketResponse.conversation;
      setMessagesList((prevMessages) => {
        return prevMessages.map((msg) => {
          if (msg.conversation_id === newMessage.conversation_id) {
            return {
              ...msg,
              status: newMessage.status,
            };
          }
          return msg;
        });
      });
    }
  }, [socketResponse, phone]);

  return (
    <>

      {/* Render Messages here */}
      <Stack
        ref={chatContainerRef}
        onScroll={handleScroll}
        direction={"column"}
        spacing={1}
        sx={{
          p: isDesktop ? 1 : 0,
          height: "70vh",
          overflow: "auto",
          pb: 2,
          backgroundImage: `url(${WhatsappBgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {loading === LoadState.InProgress && (
          <>
            <Skeleton height={"30px"} />
            <Skeleton height={"30px"} />
            <Skeleton height={"30px"} />
            {/* <Skeleton height={"30px"} />
              <Skeleton height={"30px"} /> */}
          </>
        )}
        {loading === LoadState.Failed && error && (
          <>
            {error === "WHATSAPP_NOT_SCANNED" ? (
              <WhatsAppQRScanRequired errorType="WHATSAPP_NOT_SCANNED" />
            ) : error === "WHATSAPP_SERVICE_OFF" ? (
              <WhatsAppQRScanRequired errorType="WHATSAPP_SERVICE_OFF" />
            ) : (
              <Box
                minHeight={100}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box display={"flex"} justifyContent={"center"} mb={1}>
                  <ErrorOutline />
                </Box>
                <Box display={"flex"} justifyContent={"center"} width={"80%"}>
                  <Typography
                    variant="body1"
                    textAlign={"center"}
                    fontWeight={600}
                  >
                    {error}
                  </Typography>
                </Box>
              </Box>
            )}
          </>
        )}

        {messagesList?.length > 0 && messagesList.map((item, index) => {
          return (
            <WhatsAppMessageRow
              key={index}
              data={item}
              currentPhone={phone}
              whatsappNumber={whatsappNumber}
              scannedPhoneNumber={scannedPhoneNumber}
              propUseQRSend={!!propUseQRSend}
              messagesList={messagesList}
              onReplySelect={handleReplySelect}
              onForwardMessage={onForwardMessage}
              onRestrictMessage={onRestrictMessage}
              onShowRestrictedMessage={onShowRestrictedMessage}
              visibleRestrictedMessages={visibleRestrictedMessages}
            />
          );
        })}
      </Stack>

      {/* bottom Message form section */}
      <Stack
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `1px solid ${theme.palette.divider}`,
          p: 1,
          height: isDesktop ? "6vh" : "6vh"
        }}
      >
        {(loading === LoadState.InProgress && tablePagination.pageNumber === 1) ? (
          <>
            <Skeleton height={"40px"} />
          </>
        ) : (<>
          {showAttachmentOptions && (
            <Box
              data-attachment-options
              sx={{
                position: "absolute",
                bottom: "100%",
                left: isDesktop ? 16 : 8,
                mb: 1,
                backgroundColor: theme.palette.background.paper,
                borderRadius: 2,
                boxShadow: theme.shadows[8],
                border: `1px solid ${theme.palette.divider}`,
                p: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                minWidth: 200,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() =>
                  setShowSelectWhatsappTemplate({
                    isFromStartConversation: false,

                    isNormalSelect: true,
                  })
                }
              >
                <AutoAwesomeMosaic sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2">Select Template</Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() => setShowSelectQuickReplyTemplate(true)}
              >
                <RocketLaunch sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2">Quick Reply</Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() => {
                  handleSendWhatsapp("IMAGE");
                  setShowAttachmentOptions(false);
                }}
              >
                <PhotoCamera sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2">Photo / Image</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() => {
                  handleSendWhatsapp("VIDEO");
                  setShowAttachmentOptions(false);
                }}
              >
                <SmartDisplayIcon sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2">Video</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1,
                  borderRadius: 1,
                  // cursor: documentSendingDisabled ? "not-allowed" : "pointer",
                  cursor: "pointer",

                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() => {
                  handleSendWhatsapp("DOCUMENT");
                  setShowAttachmentOptions(false);
                }}
              >
                <InsertDriveFile
                  sx={{
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "inherit",
                  }}
                >
                  Document
                </Typography>
              </Box>
            </Box>
          )}

          <form onSubmit={handleSubmit}>
            {replyingTo && (
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 1,
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08),
                }}
              >
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <ReplyOutlined fontSize="small" color="primary" />
                  <Box flexGrow={1}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        lineHeight: 1.2,
                      }}
                    >
                      {replyingTo.created_by_name
                        ? replyingTo.created_by_name
                        : "You"}
                    </Typography>

                    {renderReplySnippet()}
                  </Box>
                  <IconButton
                    size="small"
                    onClick={clearReplySelection}
                    aria-label="Cancel reply"
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </Stack>
              </Paper>
            )}

            {isStart || currentUseQRSend ? (
              <Grid container spacing={isDesktop ? 2 : 1} alignItems="center">
                {!currentUseQRSend && (
                  <Grid item xs="auto">
                    <Button
                      disabled={
                        currentUseQRSend &&
                        (error === "WHATSAPP_NOT_SCANNED" ||
                          error === "WHATSAPP_SERVICE_OFF")
                      }
                      data-attachment-options
                      sx={{
                        position: "relative",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                        minWidth: 40,
                        borderRadius: "50%",
                        backgroundColor: theme.palette.grey[200],
                        padding: 0,
                        "&:hover": {
                          backgroundColor: theme.palette.grey[300],
                        },
                        "&:disabled": {
                          backgroundColor: theme.palette.grey[100],
                          color: theme.palette.grey[400],
                        },
                      }}
                      onClick={() =>
                        setShowAttachmentOptions(!showAttachmentOptions)
                      }
                    >
                      <Add sx={{ fontSize: 20 }} />
                    </Button>
                  </Grid>
                )}

                <Grid item xs>
                  <CustomTextField
                    fullWidth
                    id="message"
                    value={values.message}
                    multiline
                    minRows={1}
                    maxRows={5}
                    disabled={
                      currentUseQRSend &&
                      (error === "WHATSAPP_NOT_SCANNED" ||
                        error === "WHATSAPP_SERVICE_OFF")
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      borderRadius: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        fontSize: isDesktop ? "1rem" : "0.875rem",
                        alignItems: "flex-end",
                        "& textarea": {
                          overflow: "auto !important",
                        },
                      },
                    }}
                    onChange={handleChange}
                    placeholder="Type message...."
                    size={isDesktop ? "medium" : "small"}
                  />
                </Grid>

                <Grid item xs="auto">
                  <Button
                    variant="contained"
                    size={isDesktop ? "medium" : "small"}
                    type="submit"
                    onClick={() => setButtonClicked("send")}
                    disabled={(values.message || "").length < 1 || saveLoading}
                    startIcon={
                      saveLoading ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : null
                    }
                    sx={{
                      borderRadius: 2,
                      minWidth: isDesktop ? 80 : 60,
                      height: isDesktop ? 40 : 36,
                    }}
                  >
                    {saveLoading ? "Sending..." : "Send"}
                  </Button>
                </Grid>

                <Grid item xs="auto" position={"relative"}>
                  <Tooltip title="Scroll to bottom">
                    <Button
                      data-attachment-options
                      sx={{
                        position: "relative",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                        minWidth: 40,
                        borderRadius: "50%",
                        zIndex: 10,
                        backgroundColor: theme.palette.grey[200],
                        paddingBottom: 2,
                        "&:hover": {
                          backgroundColor: theme.palette.grey[300],
                        },
                        "&:disabled": {
                          backgroundColor: theme.palette.grey[100],
                          color: theme.palette.grey[400],
                        },
                      }}
                      onClick={() => {
                        scrollToBottom(true);
                      }}
                    >
                      <ArrowBackIosIcon
                        sx={{ fontSize: 20, rotate: "-90deg" }}
                      />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={isDesktop ? 2 : 1} alignItems="center">
                {useMetaService && (
                  <>
                    <Grid item xs>
                      <Button
                        variant="contained"
                        fullWidth
                        size={"small"}
                        type="submit"
                        // onClick={() => setButtonClicked("start")}
                        onClick={() =>
                          setShowSelectWhatsappTemplate({
                            isFromStartConversation: true,

                            isNormalSelect: false,
                          })
                        }
                        disabled={saveLoading}
                        startIcon={
                          saveLoading ? (
                            <CircularProgress color="inherit" size={16} />
                          ) : null
                        }
                        endIcon={
                          <SendIcon
                            sx={{
                              color: `${"white"}`,
                            }}
                          />
                        }
                        sx={{
                          borderRadius: 2,
                          height: isDesktop ? 40 : 36,
                        }}
                      >
                        {saveLoading
                          ? "Sending..."
                          : "Select template to Start Conversation"}
                      </Button>
                    </Grid>
                  </>
                )}
                {!useMetaService && (
                  <>
                    {" "}
                    <Grid item xs>
                      <CustomTextField
                        fullWidth
                        id="message"
                        value={values.message}
                        multiline
                        rows={1}
                        disabled={
                          currentUseQRSend &&
                          (error === "WHATSAPP_NOT_SCANNED" ||
                            error === "WHATSAPP_SERVICE_OFF")
                        }
                        sx={{
                          backgroundColor: theme.palette.background.paper,
                          borderRadius: 2,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            fontSize: isDesktop ? "1rem" : "0.875rem",
                            alignItems: "flex-end",
                          },
                        }}
                        onChange={handleChange}
                        placeholder="Type message...."
                        size={isDesktop ? "medium" : "small"}
                      />
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        variant="contained"
                        size={isDesktop ? "medium" : "small"}
                        type="submit"
                        onClick={() => setButtonClicked("send")}
                        disabled={
                          (values.message || "").length < 1 || saveLoading
                        }
                        startIcon={
                          saveLoading ? (
                            <CircularProgress color="inherit" size={16} />
                          ) : null
                        }
                        sx={{
                          borderRadius: 2,
                          minWidth: isDesktop ? 80 : 60,
                          height: isDesktop ? 40 : 36,
                        }}
                      >
                        {saveLoading ? "Sending..." : "Send"}
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </form>
        </>
        )}
      </Stack>

      {(showSelectWhatsappTemplate.isFromStartConversation ||
        showSelectWhatsappTemplate.isNormalSelect) && (
          <SelectWhatsappTemplate
            open={true}
            toNumber={phone}
            onClose={() => {
              setShowSelectWhatsappTemplate({
                isFromStartConversation: false,

                isNormalSelect: false,
              });
              setSaveLoading(false);
            }}
            isFromStartConversation={
              showSelectWhatsappTemplate.isFromStartConversation
            }
          />
        )}

      {showSelectQuickReplyTemplate && (
        <SelectQuickReplyTemplate
          open={true}
          toNumber={phone}
          onClose={() => {
            setShowSelectQuickReplyTemplate(false);
            setSaveLoading(false);
          }}
          onSelectTemplate={(message) => {
            setFieldValue("message", message);
            setShowSelectQuickReplyTemplate(false);
          }}
        />
      )}

      {showLocationPicker && (
        <MapPicker
          open={showLocationPicker}
          onClose={() => setShowLocationPicker(false)}
          onHandleLocationSelect={handleLocationSelect}
        />
      )}
    </>
  );
});
